var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M1.53345 19.4137C1.53345 21.1016 2.89833 22.4664 4.5862 22.4664C5.42759 22.4664 6.21297 22.1479 6.76665 21.5942L12.3313 16.0253L13.8227 17.5167C13.622 18.2495 13.8141 19.0693 14.3942 19.6536L16.5572 21.8166C17.4205 22.6759 18.8027 22.6845 19.6534 21.834C20.5039 20.9834 20.4953 19.6015 19.6358 18.7378L17.4728 16.5748C16.8885 15.9947 16.0686 15.803 15.3361 16.0037L13.8447 14.5161L14.8039 13.5569C16.8446 14.0716 19.0949 13.5349 20.6869 11.9783C21.7814 10.9055 22.3838 9.5448 22.4662 8.13639V8.06232C22.4662 7.58664 22.0736 7.20288 21.5898 7.20288C21.3497 7.20288 21.1317 7.29917 20.9702 7.45157L20.7133 7.70458L19.8322 8.56786C19.2781 9.10872 18.489 9.42687 17.6385 9.42687C16.7927 9.42687 16.0466 9.0564 15.4929 8.51122C14.9479 7.95763 14.5729 7.2072 14.5729 6.36139C14.5729 5.51098 14.8912 4.72176 15.432 4.1677L16.2953 3.28651L16.5482 3.02967C16.7008 2.86824 16.7969 2.65018 16.7969 2.40999C16.7969 1.92619 16.4133 1.53351 15.9375 1.53351H15.8634C14.455 1.61611 13.0944 2.21837 12.0215 3.31291C10.4649 4.90483 9.93258 7.15517 10.447 9.19181L9.48374 10.1551L5.45831 6.12586V5.02243L2.84174 3.71405L1.53345 5.02234L2.84174 7.63896H3.9405L7.97015 11.6644L2.40561 17.2333C1.85202 17.7869 1.53345 18.5723 1.53345 19.4137ZM3.7139 19.1956C3.7139 18.5939 4.20239 18.1055 4.80417 18.1055C5.40599 18.1055 5.89439 18.5939 5.89439 19.1956C5.89439 19.7974 5.40599 20.286 4.80417 20.286C4.20244 20.286 3.7139 19.7974 3.7139 19.1956Z"
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }